import React, { FC } from 'react';

import {
  Background,
  FontAwesomeIcon,
  PostPurchase,
  ProductData
} from '@appcharge/shared-ui';

import useOffersUI from 'api/useOffersUI';
import useTheme from 'api/useTheme';
import { cn } from 'components/lib/utils';
import Typography from 'components/Typography/Typography';
import { IResolvedProgressBarMission } from 'views/Offers/utils/resolveProgressBarPoints';

import 'common/styles.scss';

interface IStandardPopupPreviewProps {
  publisherId?: string;
  currentOfferUI: string;
  currentPrice: number;
  previewProducts: ProductData[];
  progressBarPoints?: IResolvedProgressBarMission[];
}

export const StandardPopupPreview: FC<IStandardPopupPreviewProps> = ({
  publisherId,
  currentOfferUI,
  currentPrice,
  previewProducts,
  progressBarPoints
}): React.ReactElement => {
  const { getGeneralTheme: generalTheme } = useTheme(publisherId);
  const { getOfferUI } = useOffersUI(publisherId, currentOfferUI);
  const offerData = getOfferUI?.data;

  return (
    <div className="w-1/2 h-full bg-zinc-100 px-16 py-10 overflow-y-auto">
      <div className="mb-11 flex items-center justify-between">
        <Typography className="text-p-xl font-semibold">Preview</Typography>
        <div className="flex items-center bg-base-white rounded-lg shadow border border-base-sidebarBorder p-1.5">
          <FontAwesomeIcon
            icon="fa-solid fa-mobile"
            className={cn('text-indigo-300 text-[18px] w-8 h-8 cursor-pointer')}
          />
          <hr className="bg-base-border w-[1px] h-6 mx-1" />
          <FontAwesomeIcon
            icon="fa-regular fa-desktop"
            className={cn(
              'text-neutral-300 text-[18px] w-8 h-8 cursor-not-allowed'
            )}
          />
        </div>
      </div>
      <div className="flex justify-center">
        <div className="iphone-mock" id="iphone-mock-post-purchase">
          <Background
            backgroundImageMobile={
              !generalTheme?.isLoading &&
              generalTheme.data?.backgroundImageMobile
            }
            backgroundImageDesktop={
              !generalTheme.isLoading &&
              generalTheme.data?.backgroundImageDesktop
            }
            width="100%"
            height="100%"
            position="absolute"
          />
          <PostPurchase
            isPreview
            title={offerData?.specialOffer?.title || ''}
            titleColor={offerData?.specialOffer?.fontColor.colorOne}
            titleWeight={offerData?.specialOffer?.fontWeight}
            titleSize={offerData?.specialOffer?.fontSize.toString()}
            borderWidth={offerData?.borderWidth}
            borderColor={offerData?.borderColor}
            modalContainer={() =>
              document.getElementById('iphone-mock-post-purchase')
            }
            backgroundImage={offerData?.backgroundImage}
            products={previewProducts}
            onActionBtnClicked={async () => true}
            onClose={() => {}}
            prices={{
              priceDisplay: `$${currentPrice}`,
              priceInUsdCents: currentPrice
            }}
            progressBarPoints={progressBarPoints}
          />
        </div>
      </div>
    </div>
  );
};
